﻿import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'sk-split-bar',
    templateUrl: './splitBar.html',
    styleUrls: ['./splitBar.scss']
})
export class SplitBarComponent implements OnInit, OnChanges {

    @Input('input-type') splitBarItemInputType: string = 'raw'; // raw / decimal / percent
    @Input('display-type') splitBarItemDisplayType: string = 'percent'; // raw / percent

    @Input('data') splitBarInputData: any[];
    //= [
    //    {
    //        //value: 45,
    //        value: 3,
    //        //value: 0.3,
    //        color: 'red',
    //        //tooltip: 'hello'
    //    },
    //    {
    //        //value: 1980,
    //        value: 97,
    //        //value: 0.97,
    //        color: 'green',
    //        //tooltip: 'bye'
    //    }
    //];

    totalValue: number = 0;

    //splitBarData: any[];
    //    this.splitBarData = [];

    constructor(
    ) {

    }

    getInputItemValue(item): number {
        if (this.splitBarItemInputType == 'percent') {
            return Number(item.value); // could be in decimal or percent
        }
        else if (this.splitBarItemInputType == 'decimal') {
            return Number((item.value * 100).toFixed(2));
        }
        else if (this.splitBarItemInputType == 'raw') {
            return Number(item.value);
        }
    }

    getDisplayItemValue(item): string {
        if (this.splitBarItemDisplayType == 'percent') {
            return `${item.value}%`; // could be in decimal or percent
        }
        else if (this.splitBarItemDisplayType == 'decimal') {
            return (item.value * 100).toFixed(2);
        }
        else if (this.splitBarItemDisplayType == 'raw') {
            return item.value.toString();
        }
    }

    getPercentItemValue(item): string {
        if (this.splitBarItemInputType == 'percent') {
            return `${item.value}%`; // could be in decimal or percent
        }
        else if (this.splitBarItemInputType == 'decimal') {
            return `${(item.value * 100).toFixed(2)}%`;
        }
        else if (this.splitBarItemInputType == 'raw') {
            return `${((item.value / this.totalValue) * 100).toFixed(2)}%`;
        }
    }

    processInputs() {
        this.totalValue = 0;

        if (this.splitBarInputData.length > 0) {

            this.splitBarInputData.forEach((item) => {
                //this.loggerService.logData(item);
                const val = this.getInputItemValue(item);
                //this.loggerService.logData(val);
                this.totalValue += val;
            });
            //this.loggerService.logData(this.totalValue);

            this.splitBarInputData.forEach((item) => {
                item.processedValue = this.getInputItemValue(item);
                item.displayValue = this.getDisplayItemValue(item);
                item.percentValue = this.getPercentItemValue(item);
                //this.loggerService.logData(item);
            });
        }
    }

    ngOnInit() {        
        this.processInputs();
    }
    ngOnChanges() {
        this.processInputs();
    }
}
